<template>
  <div class="container-fluid py-4">

    <div class="row justify-content-end mb-15">
      <div class="col-auto d-flex align-items-center gap-2 ms-auto">
        <Select2
            containerClass="col-auto fv-row"
            :selectClass="'form-select form-control-sm form-select-solid'"
            :multiple="false"
            :isRequired="true"
            v-model="selectedPopulation"
            style="min-width: 250px;"
            name="population">
          <option value="false">{{ $t('qvct_survey.survey_report.all_populations') }}</option>
          <option value="true">{{ $t('qvct_survey.survey_report.by_populations') }}</option>
        </Select2>
      </div>

      <div class="col-auto d-flex align-items-center gap-2">
        <Select2
            containerClass="col-auto fv-row"
            :selectClass="'form-select form-control-sm form-select-solid'"
            :multiple="true"
            :isRequired="true"
            v-model="selectedCategories"
            style="min-width: 300px;"
            name="category">
          <option v-for="category in parentCategories"
                  :key="category.id"
                  :value="category.id">
            {{ category.name }}
          </option>
        </Select2>

        <Button type="button" btnClass="btn py-2 btn-primary" :btn-text="$t('button.download_word')" @click="openDownloadModal" />

      </div>
    </div>
       <div class="row mb-20">
      <div class="col-12">
        <RespondentParticipationChart
            :total-respondents="globalTotalRespondents"
            :total-participants="globalTotalParticipants"
            :title="$t('qvct_survey.survey_report.response_rate') || 'Taux de réponse'"
        />
      </div>
         <RespondentsFeedback :survey-opinion="surveyOpinion" />
    </div>

    <h1 class="text-center mb-10 mt-5 text-dark">{{ $t('qvct_survey.survey_report.list') }}</h1>

    <template v-for="categoryId in selectedCategories" :key="`section-${categoryId}`">
    
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h2 class="text-dark mb-0">{{ getCategoryName(categoryId) }}</h2>
        <button class="btn btn-link btn-sm" @click="toggleCollapsed(categoryId)">
          <i :class="collapsedCategories.has(categoryId) ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
          {{ collapsedCategories.has(categoryId) ? ($t('qvct_survey.survey_report.expand')) : ($t('qvct_survey.survey_report.collapse') || 'Plier') }}
        </button>
      </div>
      

      <div v-show="!collapsedCategories.has(categoryId)">


        <div v-if="hasPopulationData(categoryId)" class="row justify-content-center mb-20" :data-export-category="categoryId" data-export-type="population-chart">
          <div class="col-md-12">
            <PopulationChart
              :key="`pop-${getCategoryRenderKey(categoryId)}`"
              :surveyReport="getCategoryReport(categoryId)"
              :selectedCategory="categoryId"
              :selectedPopulation="selectedPopulation"
              :title="populationChartTitle"
            />
          </div>
        </div>
       
        

<!--        <div v-if="selectedPopulation === 'true' && hasPopulationData(categoryId)" class="card shadow-sm mb-20">
          <div class="card-body" :data-export-category="categoryId" data-export-type="population-individual">
            <h3 class="text-center mb-5 text-dark">{{ $t('qvct_survey.survey_report.distribution') }}</h3>
            <div class="row g-6">
              <div class="col mb-10" v-for="groupId in getPopulationGroupsFor(categoryId)" :key="`doughnut-${groupId}-${categoryId}`">
                <div v-if="hasSubCategoriesFor(categoryId)">
                  <PopulationIndividualChart
                    :key="`popind-${groupId}-${getCategoryRenderKey(categoryId)}`"
                    :surveyReport="getCategoryReport(categoryId)"
                    :selectedCategory="categoryId"
                    :populationId="groupId"
                  />
                </div>
                <div v-else class="text-center py-4">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
                  <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div v-if="isQvct(categoryId) || isRps(categoryId)" class="card shadow-sm mb-20">
          <div class="card-body">
            <h2 class="card-title text-center mb-10">{{ isQvct(categoryId) ? $t('qvct_survey.survey_report.qvct_chart') : $t('qvct_survey.survey_report.rps_chart') }}</h2>
            <RadarOverviewFirst
                :key="`radar-overview-first-${getCategoryRenderKey(categoryId)}`"
                :surveyReport="getCategoryReport(categoryId)"
                :selectedCategory="categoryId"
                :selectedPopulation="selectedPopulation"
            />

            <template v-if="isQvct(categoryId)">
              <h2 class="card-title text-center mt-20 my-10">{{ $t('qvct_survey.survey_report.qvct_level_chart') }}</h2>
              <RadarOverviewSecond
                  :key="`radar-overview-second-${getCategoryRenderKey(categoryId)}`"
                  :surveyReport="getCategoryReport(categoryId)"
                  :selectedCategory="categoryId"
                  :selectedPopulation="selectedPopulation"

              />
            </template>

        
          <FirstLevelSubcategoryRadars
          v-if="isQvct(categoryId)"
          class="p-10 mt-20"
          :category-id="categoryId"
          :category-report="getCategoryReport(categoryId)"
          :selected-population="selectedPopulation"
         />
          </div>
        </div>
        <div v-if="hasPopulationData(categoryId)" class="card shadow-sm mb-20" :data-export-category="categoryId" data-export-type="subcategories-chart">
          <div class="card-body">
            <h2 class="card-title text-center mb-10">
              {{ getCategoryName(categoryId).toLowerCase().includes('qvct')
                ? $t('qvct_survey.survey_report.qvct_comparison_chart')
                : getCategoryName(categoryId).toLowerCase().includes('rps')
                    ? $t('qvct_survey.survey_report.rps_comparison_chart')
                    : $t('qvct_survey.survey_report.category_comparison_chart') }}
            </h2>
            <div v-if="hasSubCategoriesFor(categoryId)">
              <SubcategoriesChart
                :key="`subc-${getCategoryRenderKey(categoryId)}`"
                :surveyReport="getCategoryReport(categoryId)"
                :selectedCategory="categoryId"
                :selectedPopulation="selectedPopulation"
                :forceComfort="getCategoryName(categoryId).toLowerCase().includes('qvct')"
                :forceStress="getCategoryName(categoryId).toLowerCase().includes('rps')"
              />
            </div>
            <div v-else class="text-center py-4">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
          </div>
        </div>

        <div class="card shadow-sm" :data-export-category="categoryId" data-export-type="radar-section">
          <div class="card-body">
            <h2 class="text-center mb-15 text-dark">{{ $t('qvct_survey.survey_report.detailed_analysis') }}</h2>

            <div v-if="hasSubCategoriesFor(categoryId)" class="mb-20">
              <h5 class="card-title text-center">{{$t('qvct_survey.survey_report.legend')}}</h5>
              <div class="d-flex justify-content-center flex-wrap gap-2">
                <span v-for="mark in responseMarks"
                      :key="mark.name"
                      class="badge p-2"
                      :style="{ backgroundColor: mark.color, color: '#ffffff', border: `1px solid ${mark.color}`, fontSize:'12px' }">
                  {{ mark.name }} ({{ mark.min_percent }}% - {{ mark.max_percent }}%)
                </span>
              </div>
            </div>

            <div v-if="!hasSubCategoriesFor(categoryId)" class="text-center py-4 mt-4">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>

            <div v-else-if="getAvailableSecondLast(categoryId).length > 0" class="row row-cols-1 row-cols-lg-2 g-4">
              <div class="col mb-10" v-for="subCat in getAvailableSecondLast(categoryId)" :key="subCat.path.join('-')" :data-export-category="categoryId" data-export-type="radar-chart">
                <RadarChart
                  :key="`radar-${getCategoryRenderKey(categoryId)}-${subCat.path.join('-')}`"
                  :surveyReport="getCategoryReport(categoryId)"
                  :selectedCategory="categoryId"
                  :selectedPopulation="selectedPopulation"
                  :subCategoryPath="subCat.path"
                  :subCategoryName="subCat.label"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-if="hasPopulationData(categoryId)" class="card shadow-sm mb-20" :data-export-category="categoryId" data-export-type="index-marker-table">
          <div class="card-body">
            <h2 class="text-center mb-4 text-dark">{{$t('qvct_survey.survey_report.report')}}</h2>
            <div v-if="hasSubCategoriesFor(categoryId)">
              <IndexMarkerTable
                :key="`idx-${getCategoryRenderKey(categoryId)}`"
                :surveyReport="getCategoryReport(categoryId)"
                :selectedCategory="categoryId"
                :selectedPopulation="selectedPopulation"
              />
            </div>
            <div v-else class="text-center py-4">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>



    <DownloadReportModal
      :visible="isDownloadModalOpen"
      :categories="selectedCategories.map(id => ({ id, name: getCategoryName(id) }))"
      :busy="isExportBusy"
      @close="isDownloadModalOpen=false"
      @confirm="handleDownloadConfirm"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import Select2 from "@/components/Select2.vue";
import PopulationChart from "./charts/PopulationChart.vue";
import SubcategoriesChart from "./charts/SubcategoriesChart.vue";
import RadarChart from "./charts/RadarChart.vue";
import RadarOverviewFirst from "./charts/RadarOverviewFirst.vue";
import RadarOverviewSecond from "./charts/RadarOverviewSecond.vue";
import PopulationIndividualChart from "./charts/PopulationIndividualChart.vue";
import IndexMarkerTable from "./IndexMarkerTable.vue";
import DownloadReportModal from "./modals/DownloadReportModal.vue";
import RespondentsFeedback from "./RespondentsFeedback.vue";
import Button from "@/components/Button.vue";
import RespondentParticipationChart from "./charts/RespondentParticipationChart.vue";
import { useI18n } from 'vue-i18n'
import FirstLevelSubcategoryRadars from './FirstLevelSubcategoryRadars.vue'


const props = defineProps({
  surveyReport: { type: Object, required: true, default: () => ({ all_populations: {} }) },
  survey: Object,
  surveyParentCategory: Array,
  responseMarks: Array,
  surveyOpinion: Array
})
const { t } = useI18n();
const emits = defineEmits(['changeStats'])

const selectedPopulation = ref('false')
const selectedCategories = ref([])

const parentCategories = computed(() => (props.surveyParentCategory || []).map(cat => ({ id: cat.id, name: cat.name })))

const getCategoryName = (categoryId) => parentCategories.value.find(c => c.id === categoryId)?.name || ''

const populationChartTitle = computed(() => selectedPopulation.value === 'false' ? 'Répartition par population' : t('qvct_survey.survey_report.distribution_by_population'))

const globalTotalRespondents = computed(() => {
  const total = props.surveyReport?.all_populations?.total_respondents
  if (typeof total === 'number') return total
  // fallback: sum population totals if available
  const keys = Object.keys(props.surveyReport || {}).filter(k => k !== 'all_populations')
  if (!keys.length) return 0
  return keys.reduce((sum, k) => sum + (props.surveyReport[k]?.total_respondents || 0), 0)
})

const globalTotalParticipants = computed(() => {
  // participator count provided by `survey`
  const p = props.survey?.participator ?? props.survey?.participants ?? 0
  return Number(p) || 0
})

const isQvct = (categoryId) => getCategoryName(categoryId).toLowerCase().includes('qvct')
const isRps = (categoryId) => getCategoryName(categoryId).toLowerCase().includes('rps')

const collapsedCategories = ref(new Set())
const toggleCollapsed = (categoryId) => {
  const set = new Set(collapsedCategories.value)
  if (set.has(categoryId)) set.delete(categoryId); else set.add(categoryId)
  collapsedCategories.value = set
}

const categoryReports = ref({})
const categoryReportVersions = ref({})
const lastRequestedCategory = ref(null)
const reportVersion = ref(0)

watch(() => props.surveyReport, (newVal) => {
  reportVersion.value++
  if (lastRequestedCategory.value) {
    categoryReports.value[lastRequestedCategory.value] = JSON.parse(JSON.stringify(newVal || {}))
    const versions = { ...categoryReportVersions.value }
    versions[lastRequestedCategory.value] = (versions[lastRequestedCategory.value] || 0) + 1
    categoryReportVersions.value = versions
  }
}, { deep: true })

const waitForVersionChange = async (prev, timeoutMs = 10000) => {
  const start = Date.now()
  while (Date.now() - start < timeoutMs) {
    if (reportVersion.value > prev) return true
    await new Promise(r => setTimeout(r, 50))
  }
  return false
}

const loadAllSelectedReports = async () => {
  if (!selectedCategories.value.length) return
  for (const catId of selectedCategories.value) {
    const prev = reportVersion.value
    lastRequestedCategory.value = catId
    emits('changeStats', catId, selectedPopulation.value === 'true')
    await waitForVersionChange(prev)
  }
}

watch([selectedCategories, selectedPopulation], async () => { await loadAllSelectedReports() }, { immediate: true })

const getCategoryReport = (categoryId) => {
  const cached = categoryReports.value[categoryId]
  if (cached) return cached
  const hasCat = !!props.surveyReport?.all_populations?.types?.[categoryId] ||
    Object.keys(props.surveyReport || {}).some(k => k !== 'all_populations' && props.surveyReport[k]?.types?.[categoryId])
  if (hasCat) {
    if (selectedPopulation.value === 'false' && props.surveyReport.all_populations?.types?.[categoryId]) {
      return {
        all_populations: {
          ...props.surveyReport.all_populations,
          types: { [categoryId]: props.surveyReport.all_populations.types[categoryId] }
        }
      }
    }
    const filtered = {}
    Object.keys(props.surveyReport).forEach(key => {
      if (props.surveyReport[key]?.types?.[categoryId]) {
        filtered[key] = { ...props.surveyReport[key], types: { [categoryId]: props.surveyReport[key].types[categoryId] } }
      }
    })
    return filtered
  }
  return { all_populations: {} }
}

const getCategoryRenderKey = (categoryId) => `${categoryId}-${categoryReportVersions.value[categoryId] || 0}-${selectedPopulation.value}`

const getPopulationGroupsFor = (categoryId) => {
  const data = getCategoryReport(categoryId)
  if (selectedPopulation.value === 'false') {
    if (data.all_populations && data.all_populations.types && data.all_populations.types[categoryId]) {
      return Object.keys(data)
    }
    return []
  }
  return Object.keys(data || {}).filter(k => k !== 'all_populations')
}

const hasPopulationData = (categoryId) => {
  const data = getCategoryReport(categoryId)

  if (!data) return false
  if (selectedPopulation.value === 'false') {
    if (data.all_populations && data.all_populations.types) {
      const catData = data.all_populations.types[categoryId]

      if (catData) {
        if ((catData.sub_categories && Object.keys(catData.sub_categories).length > 0) || (catData.total_respondents && catData.total_respondents > 0)) {
          return true
        }
      }
      if (data.all_populations.total_respondents && data.all_populations.total_respondents > 0) {
        return true
      }
    }
    return false
  }
  const result = getPopulationGroupsFor(categoryId).length > 0
  return result
}

const hasSubCategoriesFor = (categoryId) => {
  const data = getCategoryReport(categoryId)
  if (!data) return false
  if (selectedPopulation.value === 'false') return !!data.all_populations?.types?.[categoryId]?.sub_categories
  return Object.keys(data).some(key => key !== 'all_populations' && data[key]?.types?.[categoryId]?.sub_categories)
}

const collectSecondLastNodes = (subCategoriesRoot) => {
  const results = []
  const isEmpty = (obj) => !obj || Object.keys(obj).length === 0
  const walk = (nodeSubCats, path) => {
    if (!nodeSubCats || isEmpty(nodeSubCats)) return
    Object.entries(nodeSubCats).forEach(([name, node]) => {
      const children = node?.sub_categories
      if (children && !isEmpty(children)) {
        const grandchildrenExistSomewhere = Object.values(children).some(child => child?.sub_categories && !isEmpty(child.sub_categories))
        if (!grandchildrenExistSomewhere) results.push({ label: name, path: [...path, name] })
        else walk(children, [...path, name])
      }
    })
  }
  walk(subCategoriesRoot, [])
  return results
}

const getAvailableSecondLast = (categoryId) => {
  const data = getCategoryReport(categoryId)
  if (!hasSubCategoriesFor(categoryId)) return []
  if (selectedPopulation.value === 'true') {
    const groups = Object.keys(data).filter(key => key !== 'all_populations')
    for (const popId of groups) {
      const subRoot = data[popId]?.types?.[categoryId]?.sub_categories
      if (subRoot) return collectSecondLastNodes(subRoot)
    }
    return []
  } else {
    const subRoot = data.all_populations?.types?.[categoryId]?.sub_categories
    if (subRoot) return collectSecondLastNodes(subRoot)
    return []
  }
}

const isDownloadModalOpen = ref(false)
const isExportBusy = ref(false)
const openDownloadModal = () => { isDownloadModalOpen.value = true }

const handleDownloadConfirm = async (payload) => {
  try {
    isExportBusy.value = true
    await exportSelectedToWord(payload?.selections || {})
  } finally {
    isExportBusy.value = false
    isDownloadModalOpen.value = false
  }
}



/*const exportSelectedToWord = async (selectionsByCategory) => {
  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

  const ensureChartsRendered = async () => {
    await sleep(500)

    const allCanvases = document.querySelectorAll('canvas')
    allCanvases.forEach(canvas => {
      const chart = Chart.getChart(canvas)
      if (chart) {
        chart.resize()
        chart.render()
      }
    })

    await sleep(300)
  }

  await ensureChartsRendered()

  const docParts = []

  for (const categoryId of Object.keys(selectionsByCategory)) {
    const sel = selectionsByCategory[categoryId]
    const categoryName = getCategoryName(categoryId)

    docParts.push(`<h1 class="export-title">${categoryName}</h1>`)

    if (sel.populationChart?.bar || sel.populationChart?.doughnut) {
      const section = document.querySelector(`[data-export-category="${categoryId}"][data-export-type="population-chart"]`)
      if (section) {
        const titleEl = section.querySelector('h3, .card-title, h2, h4')
        const baseTitle = titleEl ? titleEl.textContent.trim() : 'Graphique de population'

        const canvas = section.querySelector('canvas')
        if (canvas) {
          await sleep(200)
          const suffix = ' - Graphique principal'
          docParts.push(`<h2 class="export-subtitle">${baseTitle}${suffix}</h2>`)

          const imgHTML = await canvasToImgHTML(canvas, 'png')
          if (imgHTML) docParts.push(imgHTML)
        }
      }
    }

    if (sel.populationIndividual?.bar || sel.populationIndividual?.doughnut) {
      const section = document.querySelector(`[data-export-category="${categoryId}"][data-export-type="population-individual"]`)
      if (section) {
        docParts.push(`<h2 class="export-subtitle">Graphiques individuels par population</h2>`)

        const canvases = Array.from(section.querySelectorAll('canvas'))
        for (const canvas of canvases) {
          await sleep(150)
          const imgHTML = await canvasToImgHTML(canvas, 'png')
          if (imgHTML) docParts.push(imgHTML)
        }
      }
    }

    if (sel.subcategoriesChart?.bar || sel.subcategoriesChart?.doughnut) {
      const section = document.querySelector(`[data-export-category="${categoryId}"][data-export-type="subcategories-chart"]`)
      if (section) {
        const heading = section.querySelector('h2, .card-title, h3, h4')
        const baseTitle = heading ? heading.textContent.trim() : 'Comparaison des sous-catégories'

        const canvas = section.querySelector('canvas')
        if (canvas) {
          await sleep(200)
          docParts.push(`<h2 class="export-subtitle">${baseTitle}</h2>`)

          const imgHTML = await canvasToImgHTML(canvas, 'png')
          if (imgHTML) docParts.push(imgHTML)
        }
      }
    }

    if (sel.indexTable && selectedPopulation.value === 'true') {
      const section = document.querySelector(`[data-export-category="${categoryId}"][data-export-type="index-marker-table"]`)
      if (section) {
        const titleEl = section.querySelector('h2, .card-title, h3')
        if (titleEl) docParts.push(`<h2 class="export-subtitle">${titleEl.textContent.trim()}</h2>`)

        const tableEl = section.querySelector('table')
        if (tableEl) {
          docParts.push(`<div class="export-table">${tableEl.outerHTML}</div>`)
        }
      }
    }

    if (sel.radar) {
      const radarSections = Array.from(document.querySelectorAll(`[data-export-category="${categoryId}"][data-export-type="radar-chart"]`))
      if (radarSections.length > 0) {
        docParts.push(`<h2 class="export-subtitle">Analyse détaillée - Graphiques Radar</h2>`)
      }

      for (const sec of radarSections) {
        const titleEl = sec.querySelector('h4, .card-title, h3, h5')
        if (titleEl) docParts.push(`<h3 class="export-subtitle">${titleEl.textContent.trim()}</h3>`)

        const table = sec.querySelector('table')
        if (table) {
          docParts.push(`<div class="export-table small">${table.outerHTML}</div>`)
        }

        const canvas = sec.querySelector('canvas')
        if (canvas) {
          await sleep(150)
          const imgHTML = await canvasToImgHTML(canvas, 'png')
          if (imgHTML) docParts.push(imgHTML)
        }
      }
    }

    docParts.push('<div style="page-break-after: always;"></div>')
  }

  // Création du document HTML
  const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset='utf-8'>
  <title>Rapport d'Enquête</title>
  <style>
    @page {
      size: A4;
      margin: 15mm;
    }
    body {
      margin: 0 auto;
      width: 100%;
      max-width: 800px;
      font-family: Arial, sans-serif;
      font-size: 12px;
      line-height: 1.4;
    }
    .export-title {
      font-size: 18px;
      font-weight: bold;
      margin: 20px 0 15px 0;
      text-align: center;
      color: #2c3e50;
      page-break-after: avoid;
    }
    .export-subtitle {
      font-size: 14px;
      font-weight: bold;
      margin: 15px 0 10px 0;
      color: #34495e;
      page-break-after: avoid;
    }
    img.export-img {
      display: block;
      width: 100%;
      max-width: 600px;
      height: auto;
      margin: 12px auto;
      border: 1px solid #ddd;
      page-break-inside: avoid;
    }
    .export-table {
      width: 100%;
      margin: 12px 0;
      page-break-inside: avoid;
    }
    .export-table table {
      width: 100% !important;
      border-collapse: collapse;
      table-layout: fixed;
      font-size: 10px;
    }
    .export-table.small table {
      font-size: 8px;
    }
    .export-table th, .export-table td {
      border: 1px solid #ccc;
      padding: 5px;
      text-align: center;
      word-wrap: break-word;
    }
    .export-table th {
      background-color: #f8f9fa;
      font-weight: bold;
    }
    hr {
      border: none;
      border-top: 1px solid #eee;
      margin: 20px 0;
    }
  </style>
</head>
<body>
${docParts.join('\n')}
</body>
</html>`

  const blob = new Blob([html], { type: 'application/msword' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `rapport_enquete_${new Date().toISOString().slice(0, 10)}.doc`
  document.body.appendChild(a)
  a.click()

  setTimeout(() => {
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }, 100)
}*/




const exportSelectedToWord = async (selectionsByCategory) => {
  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

  const ensureChartsRendered = async () => {
    await sleep(800)

    const allCanvases = document.querySelectorAll('canvas')
    let renderedCount = 0

    allCanvases.forEach(canvas => {
      const chart = Chart.getChart(canvas)
      if (chart) {
        chart.resize()
        chart.update()
        chart.render()
        renderedCount++
      }
    })

    console.log(`${renderedCount} graphiques rendus`)
    await sleep(500 + (renderedCount * 100))
  }

  await ensureChartsRendered()

  const docParts = []

  const participationSection = document.querySelector('.row.mb-20 .col-12:first-child')
  if (participationSection) {
    const canvas = participationSection.querySelector('canvas')
    if (canvas) {
      await sleep(300)
      docParts.push(`<h2 class="export-title">${t('qvct_survey.survey_report.response_rate')}</h2>`)
      const imgHTML = await canvasToImgHTML(canvas, 'png')
      if (imgHTML) docParts.push(imgHTML)
    }
  }

  const feedbackSection = document.querySelector('RespondentsFeedback')
  if (feedbackSection) {
    docParts.push(`<h2 class="export-subtitle">${t('qvct_survey.survey_report.respondent_feedback')}</h2>`)

    const opinionCards = feedbackSection.querySelectorAll('.opinion-card')
    for (const card of opinionCards) {
      docParts.push(`<div class="export-card">${card.innerHTML}</div>`)
    }
  }

  for (const categoryId of Object.keys(selectionsByCategory)) {
    const sel = selectionsByCategory[categoryId]
    const categoryName = getCategoryName(categoryId)

    docParts.push(`<h1 class="export-title">${categoryName}</h1>`)

    if (sel.populationChart) {
      const section = document.querySelector(`[data-export-category="${categoryId}"][data-export-type="population-chart"]`)
      if (section) {
        const titleEl = section.querySelector('h3, .card-title, h2, h4') ||
            document.querySelector('h2.text-dark') ||
            { textContent: 'Répartition par population' }
        const baseTitle = titleEl.textContent.trim()

        const canvas = section.querySelector('canvas')
        if (canvas) {
          await sleep(300)
          docParts.push(`<h2 class="export-subtitle">${baseTitle}</h2>`)
          const imgHTML = await canvasToImgHTML(canvas, 'png')
          if (imgHTML) docParts.push(imgHTML)
        }
      }
    }

    if (sel.radarOverview) {
      const radarSections = document.querySelectorAll(`.card.shadow-sm.mb-20 .card-body canvas`)
      if (radarSections.length > 0) {
        docParts.push(`<h2 class="export-subtitle">${t('qvct_survey.survey_report.radar_overview')}</h2>`)

        for (const canvas of radarSections) {
          await sleep(300)
          const imgHTML = await canvasToImgHTML(canvas, 'png')
          if (imgHTML) docParts.push(imgHTML)
        }
      }
    }

    if (sel.subcategoriesChart) {
      const section = document.querySelector(`[data-export-category="${categoryId}"][data-export-type="subcategories-chart"]`)
      if (section) {
        const heading = section.querySelector('h2, .card-title, h3, h4') ||
            { textContent: 'Comparaison des sous-catégories' }
        const baseTitle = heading.textContent.trim()

        const canvas = section.querySelector('canvas')
        if (canvas) {
          await sleep(300)
          docParts.push(`<h2 class="export-subtitle">${baseTitle}</h2>`)
          const imgHTML = await canvasToImgHTML(canvas, 'png')
          if (imgHTML) docParts.push(imgHTML)
        }
      }
    }

    if (sel.indexTable) {
      const section = document.querySelector(`[data-export-category="${categoryId}"][data-export-type="index-marker-table"]`)
      if (section) {
        const titleEl = section.querySelector('h2, .card-title, h3') ||
            { textContent: 'Rapport détaillé' }
        docParts.push(`<h2 class="export-subtitle">${titleEl.textContent.trim()}</h2>`)

        const tableEl = section.querySelector('table')
        if (tableEl) {
          docParts.push(`<div class="export-table">${tableEl.outerHTML}</div>`)
        }
      }
    }

    if (sel.radar) {
      const radarSections = Array.from(document.querySelectorAll(`[data-export-category="${categoryId}"][data-export-type="radar-chart"]`))
      if (radarSections.length > 0) {
        docParts.push(`<h2 class="export-subtitle">${t('qvct_survey.survey_report.detailed_analysis')}</h2>`)
      }

      for (const sec of radarSections) {
        const titleEl = sec.querySelector('h4, .card-title, h3, h5') ||
            { textContent: 'Analyse détaillée' }
        if (titleEl) docParts.push(`<h3 class="export-subtitle">${titleEl.textContent.trim()}</h3>`)

        const table = sec.querySelector('table')
        if (table) {
          docParts.push(`<div class="export-table small">${table.outerHTML}</div>`)
        }

        const canvas = sec.querySelector('canvas')
        if (canvas) {
          await sleep(300)
          const imgHTML = await canvasToImgHTML(canvas, 'png')
          if (imgHTML) docParts.push(imgHTML)
        }
      }
    }
    // Export radars de sous-catégorie de premier niveau (FirstLevelSubcategoryRadars)
    const firstLevelRadarSections = Array.from(document.querySelectorAll(`[data-export-category="${categoryId}"][data-export-type="firstlevel-radar"]`));
    if (firstLevelRadarSections.length > 0) {
      docParts.push(`<h2 class="export-subtitle">${t('qvct_survey.survey_report.firstlevel_radars') || 'Radars par sous-catégorie principale'}</h2>`);
      for (const sec of firstLevelRadarSections) {
        const subcatName = sec.getAttribute('data-export-subcat') || '';
        docParts.push(`<h3 class="export-subtitle">${subcatName}</h3>`);
        const canvas = sec.querySelector('canvas');
        if (canvas) {
          await sleep(300);
          const imgHTML = await canvasToImgHTML(canvas, 'png');
          if (imgHTML) docParts.push(imgHTML);
        }
      }
    }

    docParts.push('<div style="page-break-after: always;"></div>')
  }

  const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset='utf-8'>
  <title>${t('qvct_survey.survey_report.report_title')}</title>
  <style>
    @page {
      size: A4;
      margin: 15mm;
    }
    body {
      margin: 0 auto;
      width: 100%;
      max-width: 800px;
      font-family: Arial, sans-serif;
      font-size: 12px;
      line-height: 1.4;
    }
    .export-title {
      font-size: 18px;
      font-weight: bold;
      margin: 20px 0 15px 0;
      text-align: center;
      color: #2c3e50;
      page-break-after: avoid;
    }
    .export-subtitle {
      font-size: 14px;
      font-weight: bold;
      margin: 15px 0 10px 0;
      color: #34495e;
      page-break-after: avoid;
    }
    .export-card {
      border: 1px solid #ddd;
      padding: 12px;
      margin: 10px 0;
      border-radius: 4px;
      page-break-inside: avoid;
    }
    img.export-img {
      display: block;
      width: 100%;
      max-width: 600px;
      height: auto;
      margin: 12px auto;
      border: 1px solid #ddd;
      page-break-inside: avoid;
    }
    .export-table {
      width: 100%;
      margin: 12px 0;
      page-break-inside: avoid;
    }
    .export-table table {
      width: 100% !important;
      border-collapse: collapse;
      table-layout: fixed;
      font-size: 10px;
    }
    .export-table.small table {
      font-size: 8px;
    }
    .export-table th, .export-table td {
      border: 1px solid #ccc;
      padding: 5px;
      text-align: center;
      word-wrap: break-word;
    }
    .export-table th {
      background-color: #f8f9fa;
      font-weight: bold;
    }
    hr {
      border: none;
      border-top: 1px solid #eee;
      margin: 20px 0;
    }
  </style>
</head>
<body>
${docParts.join('\n')}
</body>
</html>`

  const blob = new Blob([html], { type: 'application/msword' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `rapport_enquete_${new Date().toISOString().slice(0, 10)}.doc`
  document.body.appendChild(a)
  a.click()

  setTimeout(() => {
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }, 100)
}

const canvasToImgHTML = async (canvas, format = 'png') => {
  return new Promise((resolve) => {
    try {
      const img = new Image()

      img.onload = function() {
        const tempCanvas = document.createElement('canvas')
        tempCanvas.width = canvas.width
        tempCanvas.height = canvas.height
        const ctx = tempCanvas.getContext('2d')

        ctx.fillStyle = '#ffffff'
        ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height)

        ctx.drawImage(canvas, 0, 0)

        let dataUrl
        if (format === 'png') {
          dataUrl = tempCanvas.toDataURL('image/png')
        } else {
          dataUrl = tempCanvas.toDataURL('image/jpeg', 0.95)
        }

        resolve(`<img class="export-img" src="${dataUrl}" alt="Graphique" style="max-width: 100%; height: auto;" />`)
      }

      img.onerror = function() {
        console.warn('Erreur de chargement de l\'image du canvas')
        resolve('')
      }

      img.src = canvas.toDataURL('image/png')

    } catch (error) {
      console.error('Erreur conversion canvas:', error)
      resolve('')
    }
  })
}

const forceChartsRender = () => {
  const charts = document.querySelectorAll('canvas')
  charts.forEach(canvas => {
    const chart = Chart.getChart(canvas)
    if (chart) {
      chart.update()
      chart.render()
    }
  })
}


forceChartsRender()

onMounted(async () => {
  if (parentCategories.value.length > 0 && selectedCategories.value.length === 0) {
    selectedCategories.value = [parentCategories.value[0].id]
  }
})


// Respondents feedback logic extracted to RespondentsFeedback component
</script>

<style scoped>
@media (max-width: 768px) {
  .chart-wrapper { height: 250px !important; }
}

.horizontal-scroll {
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 6px;
}

.opinion-card {
  min-width: 320px;
  max-width: 420px;
  flex: 0 0 auto;
}
</style>